export const notFoundProductReducer = (
	state = {
		list: undefined,
		count: 0,
		notFoundProductData: [],
		notFoundProductDetails: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "NOT_FOUND_PRODUCT_LIST_SUCCESS":
		case "NOT_FOUND_PRODUCT_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				notFoundProductData: action.payload.notFoundProductData,
			};
		case "NOT_FOUND_PRODUCT_DETAILS":
			return {
				...state,
				notFoundProductDetails: action.payload,
			};

		case "NOT_FOUND_PRODUCT_TOGGLE_SUCCESS":
			return {
				...state,
				notFoundProductDetails: { ...state?.notFoundProductDetails, isActive: !state?.notFoundProductDetails?.isActive },
			};
		case "NOT_FOUND_PRODUCT_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
